// extracted by mini-css-extract-plugin
export default {"root":"Button_root__AWncd","primary":"Button_primary__8+zX0","secondary":"Button_secondary__CfMmH","special":"Button_special__JRbxd","ghost":"Button_ghost__DJyZl"};